import { Alert as MuiAlert, type AlertProps as MuiAlertProps } from '@mui/material';

export type AlertProps = MuiAlertProps;

export const Alert = (props: Readonly<AlertProps>) => <MuiAlert {...props} />;
